import { render } from "./LiveSqlContent.vue?vue&type=template&id=24b47c23"
import script from "./LiveSqlContent.vue?vue&type=script&lang=js"
export * from "./LiveSqlContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__